import { INITIAL_CUSTOM_SIP_HEADER_DATA } from '../constants.js';

export const createUpdateFormData = (setFormData) => (field, value) => {
    if (field?.includes('.')) {
        const [parent, child] = field.split('.');
        setFormData((prev) => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [child]: value,
            },
        }));
    } else {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    }
};

export const createUpdateMultipleFields = (setFormData) => (updates) => {
    setFormData((prev) => ({
        ...prev,
        ...updates,
    }));
};

export const createResetForm =
    (setFormData, initialData = {}) =>
    () => {
        setFormData({
            ...INITIAL_CUSTOM_SIP_HEADER_DATA,
            ...initialData,
        });
    };

export const getInitialFormData = (initialData = {}) => ({
    ...INITIAL_CUSTOM_SIP_HEADER_DATA,
    ...initialData,
});
